import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { MediaQueryService } from '@core/breakpoints';

@Component({
  selector: 'support-banner',
  templateUrl: './support-banner.component.html',
  styleUrl: './support-banner.component.scss',
  host: { class: 'w-full' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export default class SupportBannerComponent {
  private readonly mediaService = inject(MediaQueryService);
  public isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));
}
